import React, { forwardRef } from 'react'

export const CheckboxContainer = forwardRef((props, ref) => {
  return <div ref={ref} {...props} />
})
